import { Tile, TileSection } from 'foundations-components/transitional/components/Tile';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { WarningIcon } from 'foundations-assets';
import { Small } from 'foundations-components/transitional/components/Small';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';

// matches DragItem in DraggableCard
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DraggableBoardColumnItemErrorState = () => /*#__PURE__*/_jsx(View, {
  inlineSize: "100%",
  padding: "25",
  children: /*#__PURE__*/_jsx(Tile, {
    children: /*#__PURE__*/_jsx(TileSection, {
      padding: "200",
      children: /*#__PURE__*/_jsxs(TFlex, {
        direction: "column",
        align: "center",
        children: [/*#__PURE__*/_jsx(WarningIcon, {
          size: "300"
        }), /*#__PURE__*/_jsxs(Small, {
          children: [/*#__PURE__*/_jsx("strong", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              useGap: true,
              message: "customer-data-board.errorBoundaries.cardTitle"
            })
          }), /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "customer-data-board.errorBoundaries.refresh_jsx",
            options: {
              onClick: () => window.location.reload(),
              use: 'link'
            },
            elements: {
              Link: Button
            }
          })]
        })]
      })
    })
  })
});
export default DraggableBoardColumnItemErrorState;